<template>
  <div class="learingTikuScore">
    <backHeader back-addr="/indexKaoyan"></backHeader>
    <div class="mui-content" style="padding-left:10px;padding-right:10px;background:linear-gradient(to bottom, #D82A20, #DE625A);;color:white;">
                            <br />
                            <div class="">
                                <div class=""  style="text-align:center;">
                                    <span style="font-size:34px;font-weight:bold;">{{highestScore}}</span>
                                </div>
                            </div>
                            <br />
                            <div class="">
                                <div class=""  style="text-align:center;">
                                    <span>历史最高分</span>
                                </div>
                            </div>
                            <br />
                            <div style="display:flex;">
                                <div class="" style="text-align:center;flex:1;">
                                    <span style="text-align:center;font-size:20px;">{{tikuInfo.notAnswerNum}}</span>
                                </div>
                                <div class="" style="text-align:center;flex:1;">
                                    <span style="text-align:center;font-size:20px;">{{tikuInfo.wrongNum}}</span>
                                </div>
                                <div class="" style="text-align:center;flex:1;">
                                    <span style="text-align:center;font-size:20px;">{{tikuInfo.rightNum}}</span>
                                </div>
                            </div>
                            <div style="display:flex;">
                                <div class="" style="text-align:center;flex:1;">
                                    <span style="text-align:center;">未答题</span>
                                </div>
                                <div class="" style="text-align:center;flex:1;">
                                    <span style="text-align:center;">答错题</span>
                                </div>
                                <div class="" style="text-align:center;flex:1;">
                                    <span style="text-align:center;">答对题</span>
                                </div>
                            </div>
                            <br />
                </div>
                <div class="mui-content" style="padding-left:10px;padding-right:10px;">
                            <br />
                            <div class="">
                                <div class=""  style="text-align:center;vertical-align:text-top;">
                                    <span class="iconfont mui-icon zuixin-green"></span><span style="font-size:19px;">专题测试历史成绩</span>
                                </div>
                            </div>
                             <br />
                             <div class="" v-if="$store.state.mineStore.isLogin==false">
                                <div class=""  style="text-align:center;vertical-align:text-top;">
                                    <span style="font-size:12px;">登录后获取历史成绩信息</span>
                                </div>
                            </div>
                             <br />
                            <div class="" v-for="(item,index) in tikuSpecialScore"  style="display:flex;">
                                <div class="" style="text-align:center;flex:2;">
                                    <span style="text-align:center;font-size:8px;">{{item.specialName}}</span>
                                </div>
                                <div class="" style="text-align:center;flex:2;">
                                    <span style="text-align:center;font-size:8px;">{{item.day}}</span>
                                </div>
                                <div class="" style="text-align:center;flex:1;">
                                    <span style="text-align:center;font-size:8px;">{{item.time}}</span>
                                </div>
                                <div class="" style="text-align:center;flex:1;">
                                    <span style="text-align:center;font-size:8px;">{{item.score}}分</span>
                                </div>
                            </div> 
                </div>
                <div style="height:60px;"></div>
  </div>
</template>
<script>
// import IndexApi from '../api/learingInd.js'
import cfg from "./../utils/config";
import axios from "axios";
import Qs from 'qs'
import Addr from "./../utils/getAPI";
import store from "@/store/index";
import CollectElement from "@/components/collect";
import { Toast, MessageBox } from "mint-ui";
import backHeader from "./../components/back-header.vue";

export default {
  name: "learingClass",
  data() {
    return {
      highestScore:0,
      tikuSpecialScore:[],
      tikuInfo:{
        rightNum:0,//答对题目数
        wrongNum:0,//答错题目数
        notAnswerNum:0,//未答题目数
        randomId: 0 //随机答题答道哪个id的题目了
      }
    }
  },
  methods: {
    initTikuData() {
      if (this.$store.state.mineStore.isLogin == false) {
        return;
      }
      axios.post(Addr.getGoAPIPrefix() +'user/getScoreInfo', 
      Qs.stringify({
        userId:this.$store.state.mineStore.userId
      })
      ).then(res => {
        if(res.data.returnCode==100){
          console.log("get scoreInfo success");
          console.log(res.data.returnData);
          //mui.toast("获取答题成绩成功！");
          res.data.returnData.forEach((element)=>{
            if(element.split("^^")[1]>this.highestScore){
              this.highestScore=element.split("^^")[1];
            }
            this.tikuSpecialScore.push({
              specialName:element.split("^^")[0],
              score:element.split("^^")[1],
              day:element.split("^^")[2],
              time:element.split("^^")[3]
            });
          }, this);
        }
      }).catch(err => {
        Toast({
            message: "获取答题成绩异常！",
            position: "bottom",
            duration: 800
          });
         
        console.log("get scoreInfo failed");
        console.log(err);
      })
    },
    initLocalCacheData(){

      //初始化答对答错未答的题目信息
      if(localStorage.getItem("tikuInfo")===null||localStorage.getItem("tikuInfo")===undefined){
        
      }else{
        this.tikuInfo=JSON.parse(localStorage.getItem("tikuInfo"));
      }

      // //初始化专题测试的答题历史信息
      // if(localStorage.getItem("tikuSpecialScore")===null||localStorage.getItem("tikuSpecialScore")===undefined){
        
      // }else{
      //   this.tikuSpecialScore=JSON.parse(localStorage.getItem("tikuSpecialScore"));
      // }
      // //获取最高分数
      // this.tikuSpecialScore.forEach((element)=>{
      //   if(element.score>this.highestScore){
      //     this.highestScore=element.score;
      //   }
      // }, this);
    }
  },
  mounted: function() {},
  beforeDestroy() {
    console.log("beforeDestroy");
  },
  created() {
    this.initTikuData();
    this.initLocalCacheData();
  },
  components: {
    CollectElement,
    backHeader
  }
};
</script>

<style lang="scss"  scoped>
@import "../assets/baseScss";
.mint-checklist-label {
  display: flex !important;
}
.mint-checkbox {
  flex: 1 !important;
}
.mint-checkbox-label {
  flex: 1 !important;
}
#about-img {
  width: 100%;
}

p {
  margin-left: 15px;
  margin-right: 15px;
}

.mui-input-group .mui-input-row {
  height: auto;
}

.flex-container {
  /* display: -webkit-box;
  display: -webkit-flex; */
  display: flex;
  flex-wrap: wrap;
  /* -webkit-flex-flow: row wrap; */
  /* justify-content: space-between; */
  /* text-align: center; */
  /* height: 700px; */
}

.flex-container div {
  flex: 1;
  margin: 3px;
  width: 40px;
  height: 40px;
  display: inline-block;
  text-align: center;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 25px;
  background-clip: padding-box;
  min-width: 12%;
  max-width: 12%;
  vertical-align: center;
  line-height: 40px;
}

.wrong {
  color: red;
}

.right {
  color: green;
}

.notAnswer {
  color: gray;
}
</style>



// WEBPACK FOOTER //
// src/module-tiku/tikuScore.vue